<template>
  <!--  事件管理-->
  <div class="event-container">
    <deal-table
      :current-patient-list="currentPatientList"
      @clickOver="clickOver"
      @addNewMission="isShowAddMission= true"
    />
    <history-form ref="historyRef"/>
    <add-new-mission
      :is-show-add-mission="isShowAddMission"
      :car-disabled="carDisabled"
      @dealAddPatientInfo="isShowAddMission = false;"
    />
    <small-dialog
      :dialog-show="isShowSmallDialog"
      @closeDialog="isShowSmallDialog = false"
    >
      <div>{{ showSmallDialogMessage }}</div>
    </small-dialog>
    <!-- 结束弹框 -->
    <my-dialog-form
      v-model="showFinishMission"
      :width="400"
      title="提示"
      @confirmOk="isFinishMission"
    >
      <template #body>
        <div class="finish-word">
          您正在结束一个正在进行的急救事例（编号:{{
            deleteInfoNumber
          }}），请问您是否继续强制结束该事件？
        </div>
      </template>
    </my-dialog-form>
  </div>
</template>

<script>
import { addPatient, changePatient } from "@/api/hospitalList";
import { mapState } from "vuex";
import MyDialogForm from "@components/customDialog/MyDialogForm.vue";
import DealTable from "@/components/event/DealTable";
import HistoryForm from "@/components/event/HistoryForm";
import SmallDialog from "@/components/customDialog/SmallDialog";
import AddNewMission from "@/components/event/AddNewMission";
import { showWindowMessage } from "@utils/notification";

export default {
  name: "Event",
  components: {
    MyDialogForm,
    DealTable,
    HistoryForm,
    SmallDialog,
    AddNewMission
  },
  data() {
    return {
      currentPatientList: [], // 正在处理的事件列表
      carDisabled: {}, // 正在发车中的车辆,不可以选中
      isShowAddMission: false, // 添加急救车表单按钮弹窗
      isShowSmallDialog: false, // 展示小弹窗
      showSmallDialogMessage: "", // 小弹窗的提示信息
      showFinishMission: false, // 结束任务弹窗
      deleteInfoID: "", // 即将被结束的ID
      deleteInfoNumber: "", // 即将结束的病例编号
      deleteInfoRow: "", // 即将被结束的行
      carStage: {
        0: "收到报文",
        1: "出车时刻",
        2: "抵达现场",
        3: "患者上车",
        4: "到达医院",
      },
    };
  },
  computed: {
    ...mapState({
      userInfo: "userInfo",
      carObject: "carObject",
      currentList: "currentList",
    })
  },
  watch: {
    currentList: {
      handler(val) {
        Object.keys(this.carDisabled).forEach(e => {
          this.carDisabled[e] = false;
        });
        val.forEach(item => {
          item.carName = this.carObject[item.ambulanceId];
          item.stage = this.carStage[item.statu];
          this.carDisabled[item.ambulanceId] = true;
        });
        this.currentPatientList = val;
      },
      immediate: true
    }
  },
  methods: {
    /**
     * 结束急救车事件
     * @param {Object} data - 结束得事件对象
     * */
    clickOver(data) {
      ({ id: this.deleteInfoID, number: this.deleteInfoNumber, index: this.deleteInfoRow } = data);
      this.showFinishMission = true;
    },
    // 结束急救车按钮
    isFinishMission(e) {
      // 监听到子组件的点击确定按钮 ||是否结束急救车事件
      if (e === "confirm") {
        this.finishMission();
      }
      this.showFinishMission = false;
    },

    /**
     * 结束任务
     * */
    async finishMission() {
      this.showFinishMission = false;
      try {
        await changePatient({
          id: this.deleteInfoID,
          method: "endMedicalhistory",
        });
        this.currentPatientList.splice(this.deleteInfoRow, 1);
        await this.$refs.historyRef.getMissions();
      } catch (e) {
        showWindowMessage(3, e, this);
      }
      // await this.getMissions();
    },
  },
};
</script>

<style scoped lang='scss'>
.event-container {
  margin-top: 24px;
}

::v-deep {
  .el-table {
    // 整个表格圆角
    border-radius: 10px;
    font-size: 14px;

    // 表头
    .el-table__header {
      tr {
        height: 46px;
      }

      th {
        background: #F4F4F4;
        color: #666666;
      }
    }

    // 表格内容
    .el-table__body {
      tr {
        height: 43px;
      }

      td {
        // 表格的body的padding设置为0, 让height生效
        padding: 0;
        color: #333333;
      }

      .el-button {
        font-size: 14px;
        color: #2AA5E3;
      }
    }
  }
}

.finish-word {
  width: 265px;
  height: 65px;
  line-height: 22px;
}
</style>

